
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staff/[...slug]",
      function () {
        return require("private-next-pages/staff/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/staff/[...slug]"])
      });
    }
  